export const hardwareList = [
  { name: 'USB-C Hubs', highValue: true, quantity: 25 },
  { name: '5V Power Adapters', quantity: 15 },
  { name: '9V Power Adapters', quantity: 15 },
  { name: '12V Power Adapters', quantity: 15 },
  { name: 'Arduino Unos', quantity: 100 },
  { name: '9V Batteries', quantity: 10 },
  { name: 'AA Batteries', quantity: 10 },
  { name: 'AAA Batteries', quantity: 10 },
  { name: '3.7V Batteries', quantity: 10 },
  { name: 'Assorted Buttons', quantity: 10 },
  { name: 'USB Webcams', quantity: 15 },
  { name: 'Arduino Camera Modules', quantity: 10 },
  { name: 'Force Sensors (Small)', quantity: 20 },
  { name: 'Force Sensors (Medium)', quantity: 10 },
  { name: 'Force Sensors (Large)', quantity: 10 },
  { name: 'Heart Rate Sensors', quantity: 5 },
  { name: 'Hot Glue Guns', quantity: 5 },
  { name: 'IMUs (Inertial Measurement Units)', quantity: 20 },
  { name: 'Jumper Cables', quantity: 5 },
  { name: 'Keyboard and Mouse Sets', quantity: 4 },
  { name: 'MicroSD Card Readers', quantity: 10 },
  { name: 'Voice Microphones', quantity: 20 },
  { name: 'Duct Tape Rolls', quantity: 10 },
  { name: 'Masking Tape Rolls', quantity: 10 },
  { name: 'Electrical Tape Rolls', quantity: 10 },
  { name: 'Copper Tape Rolls', quantity: 4 },
  { name: 'Raspberry Pi Zero Ws', quantity: 10 },
  { name: 'RFID Sensors', quantity: 5 },
  { name: 'SD Cards (32GB)', quantity: 15 },
  { name: 'Sensor Kits', quantity: 5 },
  { name: 'Stepper Motors', quantity: 10 },
  { name: 'Ultrasonic Sensors', quantity: 100 },
  { name: 'ESP32 Boards', quantity: 40 },
  { name: 'Raspberry Pi 5', quantity: 2 },
  { name: 'NodeMCU Boards', quantity: 15 },
  { name: 'Arduino Nano Boards', quantity: 40 },
  { name: 'Light Sensors', quantity: 15 },
  { name: 'Motion Sensors (PIR)', quantity: 10 },
  { name: 'Perfboards', quantity: 1 },
  { name: 'USB Cables (Various Types)', quantity: 10 },
  { name: 'Adafruit FLORA Boards', quantity: 10 },
  { name: 'Small Solar Panels', quantity: 5 },
];

export default hardwareList;
